export interface IWinRatioConfig {
    ratio:number;
    name:string;
    duration:number;
    winLevel:number;
    bigWinLevel:number;
}

export class PossessedWinConfig {
    public static WIN_RATIOS:IWinRatioConfig[] = [
        {
            ratio : 0,
            name : "Tiny Win",
            duration : 0,
            winLevel : 0,
            bigWinLevel : -1
        },
        {
            ratio : 1,
            name : "Small Win",
            duration : 0.5,
            winLevel : 1,
            bigWinLevel : -1
        },
        {
            ratio : 3,
            name : "Medium Win",
            duration : 0.9,
            winLevel : 2,
            bigWinLevel : -1
        },
        {
            ratio : 5,
            name : "Large Win",
            duration : 2,
            winLevel : 3,
            bigWinLevel : -1
        },
        {
            ratio : 15,
            name : "Big Win 1",
            duration : 3,
            winLevel : 3,
            bigWinLevel : 1
        },
        {
            ratio : 25,
            name : "Big Win 2",
            duration : 3,
            winLevel : 3,
            bigWinLevel : 2

        },
        {
            ratio : 50,
            name : "Big Win 3",
            duration : 3,
            winLevel : 3,
            bigWinLevel : 3
        },
        {
            ratio : 100,
            name : "Big Win 4",
            duration : 3,
            winLevel : 3,
            bigWinLevel : 4
        },
        {
            ratio : 500,
            name : "Big Win 5",
            duration : 3,
            winLevel : 3,
            bigWinLevel : 5
        }
    ];

    public static getWinConfig(winRatio:number):IWinRatioConfig {
        let currentConf = PossessedWinConfig.WIN_RATIOS[0];
        for(let i:number=1; i < PossessedWinConfig.WIN_RATIOS.length; i++) {
            if(winRatio < PossessedWinConfig.WIN_RATIOS[i].ratio) break;

            currentConf = PossessedWinConfig.WIN_RATIOS[i];
        }
        return currentConf;
    }

    public static getBigWinLevels(winRatio:number):IWinRatioConfig[] {
        return PossessedWinConfig.WIN_RATIOS.filter(conf => conf.bigWinLevel > 0 && conf.ratio <= winRatio);
    }
}

